import React from 'react';
import { Box } from '@/wag-react/next-components/box';
import { Flex } from '@/wag-react/next-components/Flex';
import { Text } from '@/wag-react/core-components/text';
import { Image } from '@/wag-react/next-components/image';
import Avatar from '@/wag-react/components/Avatar';
import starRating from '../../../../../../assets/star-rating.svg';
import { getRandomSilhouetteName } from '@/utils/getRandomSilhouetteName';
type Props = {
  name: string;
  review: string;
  gender?: string;
  src?: string;
};
export const HomePageReview = ({
  gender,
  name,
  review,
  src
}: Props) => <Flex display="flex" width={['100%', '300px', '252px', '270px']} height="400px" flexDirection="column" justifyContent="space-between" alignSelf="stretch" borderRadius="8px" boxShadow="0px 4px 8px 0px rgba(0, 0, 0, 0.08)" p="24px" bg="white" boxSizing="border-box" data-sentry-element="Flex" data-sentry-component="HomePageReview" data-sentry-source-file="HomePageReview.tsx">
    {/* Top content container */}
    <Flex flexDirection="column" alignItems="flex-start" width="100%" data-sentry-element="Flex" data-sentry-source-file="HomePageReview.tsx">
      {/* Avatar at top-left */}
      <Box width="48px" height="48px" borderRadius="48px" overflow="hidden" mb="18px" data-sentry-element="Box" data-sentry-source-file="HomePageReview.tsx">
        <Avatar icon={gender && getRandomSilhouetteName({
        gender
      })} src={src} bg="#d4d4d4" width="48px" height="48px" iconHeight="48px" iconWidth="48px" imageProps={{
        alt: `${name}-avatar`
      }} data-sentry-element="Avatar" data-sentry-source-file="HomePageReview.tsx" />
      </Box>
      
      {/* Star Rating */}
      <Box display="flex" width="103px" height="18px" alignItems="flex-start" mb="10px" data-sentry-element="Box" data-sentry-source-file="HomePageReview.tsx">
        <Image src={starRating} alt="5-star rating" width="100%" height="100%" data-sentry-element="Image" data-sentry-source-file="HomePageReview.tsx" />
      </Box>
      
      {/* Review Text */}
      <Text alignSelf="stretch" color="var(--Text-charcoal, #474747)" style={{
      fontFamily: '"Hero New", sans-serif',
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0px',
      flex: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 11,
      WebkitBoxOrient: 'vertical',
      margin: '4px 0px 0px 0px'
    }} data-sentry-element="Text" data-sentry-source-file="HomePageReview.tsx">
        {review}
      </Text>
    </Flex>
    
    {/* Reviewer Name at Bottom */}
    <Text color="var(--Text-charcoal, #474747)" style={{
    fontFamily: '"Hero New", sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '0px',
    letterSpacing: '0px'
  }} data-sentry-element="Text" data-sentry-source-file="HomePageReview.tsx">
      {name}
    </Text>
  </Flex>;